import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/index';
import { Row, Col } from 'react-materialize';

class AccessDenied extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isModalOpen: true,
		};
	}

	refresh() {
		window.location.reload();
	}

	render() {
		return (
			<Row className="valign-wrapper dp-container mb-0">
				<Col s={12}>
					<div>
						<div className="dp-instructions">Audio access was denied</div>
						<Row>
							<Col s={12}>
								<div className="dp-instructions-subtitle">
									<p>
										Unfortunately, we were unable to receive your audio
										access permission.
									</p>
									<p>
										Please enable it in your browser settings in order to
										proceed. This is a required process for recording your
										answers.
									</p>
									<br />
									<p>After doing this please refresh this page.</p>
								</div>
							</Col>
						</Row>
						<Row>
							<button
								style={{ minWidth: '200px' }}
								onClick={this.refresh}
								disabled={this.props.waitingForPermission}
							>
								REFRESH SCREEN
							</button>
						</Row>
					</div>
				</Col>
			</Row>
		);
	}
}

const mapStateToProps = (state) => ({
	waitingForPermission: state.navigatorPermissions.waitingForPermission,
});

export default connect(mapStateToProps, actions)(AccessDenied);



// WEBPACK FOOTER //
// ./src/components/tech-check/AccessDenied.js